import moment    from "moment-timezone";
import state from '../state';

export default {
  local(date) {
    date = date || new Date();
    return moment.tz(date, state.adminTimezone.get().id);
  },
  utc(date) {
    date = date || new Date();
    return moment(date).utc();
  },
  fixDate(date) {
    var diff = moment(date).utcOffset() / 60 - state.adminTimezone.get().offset;
    return moment(date).utc().add(diff, 'hours').toDate();
  }
}



// WEBPACK FOOTER //
// ./src/services/datetime.service.js